(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hercules-collection-products-2"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-hc-manual-products]');

  sections.forEach((section) => {
    const grids = [...section.querySelectorAll('[data-hc-grid]')];
    const groups = [...section.querySelectorAll('[data-hc-product-group]')];
    const cards = [...section.querySelectorAll('[data-hc-product-card]')];
    const mobilePanel = section.querySelector('.hc-mobile-filter__panel');
    const filterSource = section.querySelector('[data-hc-filter-source]');
    const clearButtons = section.querySelectorAll('[data-hc-clear]');
    const sortControls = section.querySelectorAll('[data-hc-sort]');

    if (grids.length === 0 || cards.length === 0) return;

    if (mobilePanel && filterSource) {
      mobilePanel.innerHTML = filterSource.innerHTML;
    }

    const getChecked = (group) =>
      [...section.querySelectorAll(`[data-filter-group="${group}"]:checked`)].map((input) => input.value);

    const syncChecks = (changed) => {
      if (!changed.dataset.filterGroup) return;
      section
        .querySelectorAll(`[data-filter-group="${changed.dataset.filterGroup}"][value="${changed.value}"]`)
        .forEach((input) => {
          if (input !== changed) input.checked = changed.checked;
        });
    };

    const matches = (card, selected, key) => selected.length === 0 || selected.includes(card.dataset[key]);

    const apply = () => {
      const selectedType = getChecked('type');
      const selectedColor = getChecked('color');
      const selectedQuantity = getChecked('quantity');
      cards.forEach((card) => {
        const show =
          matches(card, selectedType, 'type') &&
          matches(card, selectedColor, 'color') &&
          matches(card, selectedQuantity, 'quantity');

        card.hidden = !show;
      });

      groups.forEach((group) => {
        const groupCards = [...group.querySelectorAll('[data-hc-product-card]')];
        group.hidden = groupCards.length > 0 && groupCards.every((card) => card.hidden);
      });
    };

    const sortCards = (value) => {
      grids.forEach((grid) => {
        const sorted = [...grid.querySelectorAll('[data-hc-product-card]')].sort((a, b) => {
          if (value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (value === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
          return Number(a.dataset.index) - Number(b.dataset.index);
        });

        sorted.forEach((card) => grid.appendChild(card));
      });
    };

    section.addEventListener('change', (event) => {
      const input = event.target;

      if (input.matches('[data-filter-group]')) {
        syncChecks(input);
        apply();
      }

      if (input.matches('[data-hc-sort]')) {
        sortControls.forEach((control) => {
          if (control !== input) control.value = input.value;
        });
        sortCards(input.value);
      }
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-filter-group]').forEach((input) => {
          input.checked = false;
        });
        apply();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hercules-collection-products"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-hc-manual-products]');

  sections.forEach((section) => {
    const grid = section.querySelector('[data-hc-grid]');
    const cards = [...section.querySelectorAll('[data-hc-product-card]')];
    const mobilePanel = section.querySelector('.hc-mobile-filter__panel');
    const filterSource = section.querySelector('[data-hc-filter-source]');
    const clearButtons = section.querySelectorAll('[data-hc-clear]');
    const sortControls = section.querySelectorAll('[data-hc-sort]');

    if (!grid || cards.length === 0) return;

    if (mobilePanel && filterSource) {
      mobilePanel.innerHTML = filterSource.innerHTML;
    }

    const getChecked = (group) =>
      [...section.querySelectorAll(`[data-filter-group="${group}"]:checked`)].map((input) => input.value);

    const syncChecks = (changed) => {
      if (!changed.dataset.filterGroup) return;
      section
        .querySelectorAll(`[data-filter-group="${changed.dataset.filterGroup}"][value="${changed.value}"]`)
        .forEach((input) => {
          if (input !== changed) input.checked = changed.checked;
        });
    };

    const matches = (card, selected, key) => selected.length === 0 || selected.includes(card.dataset[key]);

    const apply = () => {
      const selectedType = getChecked('type');
      const selectedColor = getChecked('color');
      const selectedQuantity = getChecked('quantity');
      cards.forEach((card) => {
        const show =
          matches(card, selectedType, 'type') &&
          matches(card, selectedColor, 'color') &&
          matches(card, selectedQuantity, 'quantity');

        card.hidden = !show;
      });
    };

    const sortCards = (value) => {
      const sorted = [...cards].sort((a, b) => {
        if (value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (value === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });

      sorted.forEach((card) => grid.appendChild(card));
    };

    section.addEventListener('change', (event) => {
      const input = event.target;

      if (input.matches('[data-filter-group]')) {
        syncChecks(input);
        apply();
      }

      if (input.matches('[data-hc-sort]')) {
        sortControls.forEach((control) => {
          if (control !== input) control.value = input.value;
        });
        sortCards(input.value);
      }
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-filter-group]').forEach((input) => {
          input.checked = false;
        });
        apply();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hercules-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hp-gallery').forEach((gallery) => {
    const thumbs = [...gallery.querySelectorAll('[data-hp-thumb]')];
    const slides = [...gallery.querySelectorAll('[data-hp-slide]')];

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.hpThumb;
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
        slides.forEach((slide) => {
          const isActive = slide.dataset.hpSlide === id;
          slide.classList.toggle('is-active', isActive);

          if (!isActive) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
          }
        });
      });
    });
  });

  document.querySelectorAll('.hp-form').forEach((form) => {
    const button = form.querySelector('[data-hp-cart-button]');
    const message = form.querySelector('[data-hp-cart-message]');
    const defaultLabel = button ? button.textContent.trim() : '';

    const getCartSectionIds = () => [
      ...new Set(
        [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map((item) => item.dataset.sectionId)
          .filter(Boolean)
      )
    ];

    const fetchCartSections = async (sectionIds) => {
      if (!sectionIds.length) return {};

      const root = window.Shopify?.routes?.root || '/';
      const cartPath = window.Shopify?.routes?.cart_url || `${root}cart`;
      const sectionUrl = new URL(cartPath, window.location.origin);
      sectionUrl.searchParams.set('sections', sectionIds.join(','));
      sectionUrl.searchParams.set('sections_url', cartPath);
      sectionUrl.searchParams.set('_hercules_cart_sections', String(Date.now()));

      const response = await fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return {};
      return response.json();
    };

    const refreshRenderedCart = (cart, sections) => {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count, .cart-count-bubble span').forEach((counter) => {
        counter.textContent = cart.item_count;
      });

      document.querySelectorAll('.cart-bubble, .cart-count-bubble').forEach((bubble) => {
        bubble.hidden = cart.item_count === 0;
        bubble.classList.toggle('visually-hidden', cart.item_count === 0);
      });

      if (!sections) return;

      getCartSectionIds().forEach((sectionId) => {
        const sectionHtml = sections[sectionId];
        if (!sectionHtml) return;

        const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const nextItems = html.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);
        const currentItems = document.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);

        if (nextItems && currentItems) {
          currentItems.innerHTML = nextItems.innerHTML;
        }

        const nextDialog = html.querySelector('cart-drawer-component dialog');
        const currentDialog = document.querySelector('cart-drawer-component dialog');

        if (nextDialog && currentDialog) {
          currentDialog.className = nextDialog.className;
          currentDialog.setAttribute('aria-labelledby', nextDialog.getAttribute('aria-labelledby') || '');
        }
      });
    };

    const dispatchCartUpdate = (cart, sections) => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: form.id || 'hercules-product-main',
          data: {
            source: 'hercules-product-main',
            itemCount: cart.item_count,
            variantId: String(new FormData(form).get('id') || ''),
            sections: sections || {}
          }
        }
      }));
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!button || button.disabled) return;

      const formData = new FormData(form);
      button.disabled = true;
      button.textContent = 'Adicionando...';
      if (message) {
        message.textContent = '';
        message.classList.remove('is-error', 'is-success');
      }

      try {
        const cartSectionIds = getCartSectionIds();
        const root = window.Shopify?.routes?.root || '/';
        const cartPath = window.Shopify?.routes?.cart_url || `${root}cart`;

        if (cartSectionIds.length) {
          formData.set('sections', cartSectionIds.join(','));
          formData.set('sections_url', cartPath);
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Não foi possível adicionar este produto.');
        }

        try {
          sessionStorage.setItem('herculesCartDirtyAt', String(Date.now()));
          document.documentElement.dataset.herculesCartDirty = 'true';
        } catch (error) {}

        const cartResponse = await fetch('/cart.js', {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();
        const sections = await fetchCartSections(cartSectionIds);

        refreshRenderedCart(cart, sections);

        if (message) {
          message.textContent = 'Produto adicionado ao carrinho.';
          message.classList.add('is-success');
        }

        button.textContent = 'Adicionado!';
        dispatchCartUpdate(cart, sections);
        window.setTimeout(() => dispatchCartUpdate(cart, sections), 250);
        window.setTimeout(() => dispatchCartUpdate(cart, sections), 800);

        window.setTimeout(() => {
          button.textContent = defaultLabel;
          button.disabled = false;
        }, 1600);
      } catch (error) {
        if (message) {
          message.textContent = error.message;
          message.classList.add('is-error');
        }

        button.textContent = defaultLabel;
        button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hercules-recurrence-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hrp-builder]').forEach((builder) => {
    const products = {};
    const selected = new Set();
    const state = {
      people: '1',
      routine: 'compact',
      line: 'rolo',
      frequency: '30',
    };

    builder.querySelectorAll('[data-hrp-product]').forEach((node) => {
      const key = `${node.dataset.key}_${node.dataset.line}`;
      products[key] = {
        key: node.dataset.key,
        kind: node.dataset.kind || 'kit',
        line: node.dataset.line,
        title: node.dataset.title,
        url: node.dataset.url,
        image: node.dataset.image,
        variantId: node.dataset.variantId,
        price: Number(node.dataset.price || 0),
        sellingPlans: {
          30: node.dataset.selling30,
          60: node.dataset.selling60,
          90: node.dataset.selling90,
        },
      };
    });

    const peopleButtons = builder.querySelectorAll('[data-hrp-people] button');
    const routineButtons = builder.querySelectorAll('[data-hrp-routine] button');
    const lineButtons = builder.querySelectorAll('[data-hrp-line] button');
    const frequencyButtons = builder.querySelectorAll('[data-hrp-frequency] button');
    const recurrenceDiscountRate = 0.05;
    const frequencyValues = ['30', '60', '90'];
    const itemContainer = builder.querySelector('[data-hrp-items]');
    const suggestionContainer = builder.querySelector('[data-hrp-suggestions]');
    const summary = builder.querySelector('[data-hrp-summary]');
    const total = builder.querySelector('[data-hrp-total]');
    const shipping = builder.querySelector('[data-hrp-shipping]');
    const discountWrap = builder.querySelector('[data-hrp-discount-wrap]');
    const originalTotal = builder.querySelector('[data-hrp-original]');
    const discountLabel = builder.querySelector('[data-hrp-discount]');
    const submit = builder.querySelector('[data-hrp-submit]');
    const message = builder.querySelector('[data-hrp-message]');
    const sellingNote = builder.querySelector('[data-hrp-selling-note]');

    const money = (cents) =>
      new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(cents / 100);

    const getProduct = (key) => products[`${key}_${state.line}`];

    const kitInfo = {
      cozinha: {
        composition: '1 rolo de 15L, 2 rolos de 30L e 1 rolo de 50L',
        items: ['1 rolo de 15L', '2 rolos de 30L', '1 rolo de 50L'],
        ideal: 'cozinha, pia, preparo de alimentos e lavanderia',
        detail: 'Um kit prático para cobrir a lixeira da pia, a lixeira principal da cozinha e dias de maior movimento.',
      },
      'banheiro-e-quartos': {
        composition: '3 rolos de 15L e 1 rolo de 30L',
        items: ['3 rolos de 15L', '1 rolo de 30L'],
        ideal: 'banheiros, lavabos, quartos e escritório',
        detail: 'Pensado para ambientes com lixeiras menores, com reforço para um banheiro maior ou lavanderia.',
      },
      'casa-completa': {
        composition: '2 rolos de 15L, 2 rolos de 30L, 2 rolos de 50L e 1 rolo de 100L',
        items: ['2 rolos de 15L', '2 rolos de 30L', '2 rolos de 50L', '1 rolo de 100L'],
        ideal: 'todos os ambientes da casa',
        detail: 'A opção mais completa para quem quer abastecer banheiros, cozinha, lavanderia e área externa de uma vez.',
      },
      familia: {
        composition: '2 rolos de 15L, 3 rolos de 30L, 2 rolos de 50L e 2 rolos de 100L',
        items: ['2 rolos de 15L', '3 rolos de 30L', '2 rolos de 50L', '2 rolos de 100L'],
        ideal: 'famílias com maior volume de lixo',
        detail: 'Mais unidades dos tamanhos usados no dia a dia e tamanhos maiores para faxinas, finais de semana e eventos.',
      },
      faxina: {
        composition: '1 rolo de 50L e 3 rolos de 100L',
        items: ['1 rolo de 50L', '3 rolos de 100L'],
        ideal: 'faxinas, garagem, quintal e descarte volumoso',
        detail: 'Focado em limpeza pesada e organização, com sacos maiores para volumes mais pesados ou espaços externos.',
      },
      'festa-e-churrasco': {
        composition: '2 rolos de 50L e 3 rolos de 100L',
        items: ['2 rolos de 50L', '3 rolos de 100L'],
        ideal: 'churrascos, festas e reuniões em casa',
        detail: 'Ajuda a lidar com o aumento de lixo em eventos e facilita a limpeza depois da confraternização.',
      },
    };

    const unitInfo = {
      'unit-15': {
        composition: 'Rolo individual de 15L',
        ideal: 'banheiros, lavabos, quartos e escritório',
        detail: 'Bom para reforçar ambientes com lixeiras menores e uso frequente no dia a dia.',
      },
      'unit-30': {
        composition: 'Rolo individual de 30L',
        ideal: 'cozinha, lavanderia e lixeira principal',
        detail: 'Um tamanho prático para complementar a rotina da cozinha e áreas de serviço.',
      },
      'unit-50': {
        composition: 'Rolo individual de 50L',
        ideal: 'cozinhas maiores, lavanderia e faxina',
        detail: 'Indicado para dias com mais volume de descarte ou para reforçar a limpeza da casa.',
      },
      'unit-100': {
        composition: 'Rolo individual de 100L',
        ideal: 'área externa, quintal, garagem e grandes volumes',
        detail: 'Ideal para complementar kits quando a casa tem descarte maior ou limpeza pesada.',
      },
    };

    const productInfo = (product) => (product.kind === 'unit' ? unitInfo[product.key] : kitInfo[product.key]) || {};

    const displayTitle = (product) =>
      product.title
        .replace(' - Econômica sem alça', ' em Rolo')
        .replace(' - Premium com alça', ' com Alça');

    const compactTitle = (product) =>
      product.title
        .replace(' Hércules - Econômica sem alça', ' em Rolo')
        .replace(' Hércules - Premium com alça', ' com Alça');

    const unitKeys = ['unit-15', 'unit-30', 'unit-50', 'unit-100'];

    const itemList = (items, fallback) => {
      if (!items || !items.length) return `<div>${fallback || 'Itens selecionados para sua recorrência.'}</div>`;
      return `<ul>${items.map((item) => `<li>${item}</li>`).join('')}</ul>`;
    };

    const renderSuggestionCard = (product, buttonLabel) => {
      const info = productInfo(product);
      const image = product.image
        ? `<img src="${product.image}" alt="${product.title}">`
        : '<div class="hrp__item-image">Produto</div>';
      const title = product.kind === 'unit' ? displayTitle(product) : compactTitle(product);

      return `
        <article class="hrp__suggestion-card">
          ${image}
          <div>
            <h4>${title}</h4>
            ${
              product.kind === 'kit'
                ? `<details class="hrp__item-details">
                    <summary>Itens do Kit</summary>
                    ${itemList(info.items, info.composition)}
                  </details>`
                : '<div class="hrp__item-details hrp__item-details--placeholder" aria-hidden="true"></div>'
            }
            <button type="button" data-add="${product.key}">${buttonLabel}</button>
          </div>
        </article>
      `;
    };

    const setActive = (buttons, activeButton) => {
      buttons.forEach((button) => button.classList.toggle('is-active', button === activeButton));
    };

    const recommendation = () => {
      let main = 'cozinha';
      let optional = ['banheiro-e-quartos', 'faxina'];
      let reason = 'Kit Cozinha';

      if (state.routine === 'complete') {
        main = 'casa-completa';
        optional = ['cozinha', 'faxina'];
        reason = 'Kit Casa Completa';
      }

      if (state.routine === 'pet') {
        main = 'casa-completa';
        optional = ['faxina', 'banheiro-e-quartos'];
        reason = 'Kit Casa Completa';
      }

      if (state.routine === 'heavy') {
        main = 'faxina';
        optional = ['festa-e-churrasco', 'casa-completa'];
        reason = 'Kit Faxina';
      }

      if (state.people === '3-4' && state.routine === 'compact') {
        main = 'casa-completa';
        optional = ['cozinha', 'banheiro-e-quartos'];
        reason = 'Kit Casa Completa';
      }

      if (state.people === '5+' && state.routine !== 'heavy') {
        main = 'familia';
        optional = state.routine === 'pet' ? ['faxina', 'festa-e-churrasco'] : ['casa-completa', 'faxina'];
        reason = 'Kit Família';
      }

      if (!selected.size) selected.add(main);
      if (!selected.has(main)) {
        selected.clear();
        selected.add(main);
      }

      return { main, optional, reason };
    };

    const render = () => {
      const rec = recommendation();
      const lineLabel = state.line === 'rolo' ? 'em Rolo' : 'com Alça';
      const frequency = frequencyValues.includes(String(state.frequency)) ? String(state.frequency) : '30';
      state.frequency = frequency;
      frequencyButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.value === frequency);
      });
      summary.textContent = `${rec.reason} ${lineLabel} a cada ${frequency} dias`;

      const currentProducts = [...selected].map(getProduct).filter(Boolean);
      const hasSellingPlan = currentProducts.every((product) => product.sellingPlans[frequency]);
      sellingNote.hidden = hasSellingPlan;

      itemContainer.innerHTML = currentProducts
        .map((product) => {
          const info = productInfo(product);
          const image = product.image
            ? `<img src="${product.image}" alt="${product.title}">`
            : '<div class="hrp__item-image">Produto</div>';
          const isRecommendedKit = product.kind === 'kit' && product.key === rec.main;
          const displayedPrice = isRecommendedKit
            ? product.price - Math.round(product.price * recurrenceDiscountRate)
            : product.price;
          return `
            <article class="hrp__basket-item hrp__basket-item--rich" data-key="${product.key}">
              ${image}
              <div>
                <h3>${displayTitle(product)}</h3>
                <p>${money(displayedPrice)}</p>
                ${
                  product.kind === 'kit'
                    ? `<details class="hrp__item-details">
                        <summary>Itens do Kit</summary>
                        ${itemList(info.items, info.composition)}
                      </details>`
                    : ''
                }
              </div>
              ${selected.size > 1 ? `<button type="button" class="hrp__item-remove" data-remove="${product.key}" aria-label="Remover ${product.title}">×</button>` : ''}
            </article>
          `;
        })
        .join('');

      const kitSuggestions = rec.optional
        .filter((key) => !selected.has(key))
        .map(getProduct)
        .filter(Boolean);

      const allKitKeys = ['cozinha', 'banheiro-e-quartos', 'casa-completa', 'familia', 'faxina', 'festa-e-churrasco'];
      const extraKitSuggestions = allKitKeys
        .filter((key) => !selected.has(key))
        .filter((key) => !rec.optional.includes(key))
        .map(getProduct)
        .filter(Boolean);

      const unitSuggestions = unitKeys
        .filter((key) => !selected.has(key))
        .map(getProduct)
        .filter(Boolean);

      const allSuggestions = [...kitSuggestions, ...extraKitSuggestions, ...unitSuggestions];
      suggestionContainer.innerHTML = allSuggestions.length
        ? `
          <section class="hrp__suggestion-group">
            <h3>Adicionar mais opções</h3>
            <div class="hrp__suggestion-rail">
              ${allSuggestions
                .map((product) => renderSuggestionCard(product, product.kind === 'unit' ? 'Adicionar produto' : 'Adicionar kit'))
                .join('')}
            </div>
          </section>
        `
        : '';

      const fullSubtotal = currentProducts.reduce((sum, product) => sum + product.price, 0);
      const recommendedProduct = getProduct(rec.main);
      const recommendedKitSelected = recommendedProduct && selected.has(rec.main) && recommendedProduct.kind === 'kit';
      const recommendedDiscount = recommendedKitSelected
        ? Math.round(recommendedProduct.price * recurrenceDiscountRate)
        : 0;
      const subtotal = fullSubtotal - recommendedDiscount;

      discountWrap.hidden = !recommendedDiscount;
      originalTotal.textContent = money(fullSubtotal);
      discountLabel.textContent = '5% OFF';
      total.textContent = money(subtotal);
      shipping.textContent = subtotal >= 9990 ? 'Frete grátis estimado para esta cesta' : `Faltam ${money(9990 - subtotal)} para frete grátis`;
    };

    const handleChoice = (buttons, key, button) => {
      setActive(buttons, button);
      state[key] = key === 'frequency' && !frequencyValues.includes(button.dataset.value)
        ? '30'
        : button.dataset.value;
      if (key === 'people' || key === 'routine') selected.clear();
      render();
    };

    peopleButtons.forEach((button) => button.addEventListener('click', () => handleChoice(peopleButtons, 'people', button)));
    routineButtons.forEach((button) => button.addEventListener('click', () => handleChoice(routineButtons, 'routine', button)));
    lineButtons.forEach((button) => button.addEventListener('click', () => handleChoice(lineButtons, 'line', button)));
    frequencyButtons.forEach((button) => button.addEventListener('click', () => handleChoice(frequencyButtons, 'frequency', button)));

    builder.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-add]');
      const removeButton = event.target.closest('[data-remove]');

      if (addButton) {
        selected.add(addButton.dataset.add);
        render();
      }

      if (removeButton) {
        selected.delete(removeButton.dataset.remove);
        render();
      }
    });

    submit.addEventListener('click', async () => {
      const items = [...selected]
        .map(getProduct)
        .filter(Boolean)
        .map((product) => {
          const item = { id: Number(product.variantId), quantity: 1 };
          const sellingPlan = product.sellingPlans[state.frequency];
          if (sellingPlan) item.selling_plan = Number(sellingPlan);
          return item;
        });

      if (!items.length) return;

      submit.disabled = true;
      message.textContent = 'Adicionando sua recorrência ao carrinho...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            attributes: {
              'Clube Hércules': `${state.frequency} dias`,
              'Perfil da casa': `${state.people} pessoas - ${state.routine}`,
              'Linha escolhida': state.line === 'rolo' ? 'Em Rolo' : 'Com Alça',
            },
          }),
        });

        if (!response.ok) throw new Error('cart');
        message.textContent = 'Cesta adicionada ao carrinho. Você pode revisar antes de finalizar.';
      } catch (error) {
        message.textContent = 'Não foi possível adicionar agora. Tente novamente em instantes.';
      } finally {
        submit.disabled = false;
      }
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
